import React from 'react'
import styles from './Response.module.scss'

const responseMap = {
	'Very Responsive': '/images/Very-Responsive.gif',
	Responsive: '/images/Responsive.gif',
	Neutral: '/images/Neutral.gif',
	'Less Responsive': '/images/Less-Responsive.gif',
	Unresponsive: '/images/Unresponsive.gif',
}

const sizeMap = {
	lg: styles.lg,
	md: styles.md,
	sm: styles.sm,
}

function Response({ label, className, size = 'lg' }) {
	const labelClass = label.replace(/\s+/g, '-').toLowerCase()
	const sizeClass = sizeMap[size]
	return (
		<div
			className={`${styles.Response} ${styles[labelClass]} ${className || ''} ${sizeClass || ''}`}
		>
			<img src={responseMap[label]} alt={label} />
			<span>{label}</span>
		</div>
	)
}

export default Response
